import { AdobeDataType, AdobeEvents, adobeTracking } from '@tv2/lib-offspring/libs/track';
import { useCallback } from 'react';

type UnknownTrackProps = {
  data: AdobeDataType;
  event: any | AdobeEvents;
};
export function useUnknownTrack() {
  const unknownTrack = useCallback(
    ({ data, event }: UnknownTrackProps) =>
      adobeTracking({
        event,
        data: {
          ...data,
        },
      }),
    []
  );

  return unknownTrack;
}
